const SUBMIT_TICKET_CTA_NON_PERSONALIZED = 'support-ticket-cta';
const WISE_OWL_FEATURE_FLAG = 'e2-enable-wise-owl-osc';

export {
  SUBMIT_TICKET_CTA_NON_PERSONALIZED,
  WISE_OWL_FEATURE_FLAG,
};
